var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.28 2.69h4.16V23H1V2.69h4.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16 1h8.12v3.38H5.16zM6.33 12.386l3.111 2.864 4.889-4.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedProjects);
export default __webpack_public_path__ + "static/media/finished-projects.8c8160ad1a745947c1dee6782012f78e.svg";
export { ForwardRef as ReactComponent };